import { DvScatterData } from './type';

export function isValidData(data: DvScatterData) {
  if (!data || !data.value || data.value.length < 3) {
    return false;
  }
  const notNumberIndex = data.value.findIndex(v => !Number.isFinite(v));
  if (notNumberIndex >= 0) {
    return false;
  }
  return true;
}
